import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { OrderCategory, TApiOrderDetails } from "../../../../api/endpoints/Order";
import { OrderPdfProps } from "../../types";
import EuCutOutProductHelpers from "../../../../utils/EuCutOutProductHelpers";
import React from "react";
import { map } from "lodash";
import { TParameterSelection } from "../../../EuCutOutConfigurator";
import SubsetTypes from "../../../../utils/SubsetTypes";
import { formatSubsetLabel } from "../../../../utils/Format";
import { TOrderProduct } from "../../../../api/endpoints/OrderProduct";

interface IProps extends OrderPdfProps {
  product: TOrderProduct<OrderCategory.EU_CUTOUT>;
}

const styles = StyleSheet.create({
  root: {
    marginBottom: '15mm'
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: '10mm',
    width: '100%'
  },
  tableTitle: {
    marginBottom: '3mm',
    paddingVertical: '1.5mm',
    fontFamily: 'Helvetica-Bold'
  },
  tableHead: {
    borderBottom: '1pt solid #f0f0f0',
    marginBottom: '3mm',
    paddingVertical: '1.5mm',
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: '3mm',
    fontSize: "8pt"
  },
  shortname: {
    width: '25%',
    paddingRight: '3mm'
  },
  subset: {
    width: '50%',
    lineHeight: '30px',
    paddingHorizontal: '3mm'
  },
  subsetType: {
    width: '25%',
    paddingLeft: '3mm'
  },
  highFrequencyWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  highFrequencyLabel: {
    fontFamily: 'Helvetica-Bold',
    marginRight: '3mm'
  }
});

interface TableRowProps {
  item: TParameterSelection
}

const TableRow = (props: TableRowProps) => {
  const { item } = props;

  return (
    <View style={styles.row}>
      <Text style={styles.shortname}>{item.parameter.name} ({item.parameter.shortname})</Text>
      <Text style={styles.subset}>{formatSubsetLabel(item.subset)}</Text>
      <Text style={styles.subsetType}>{SubsetTypes.humanize(item.subset.type)}</Text>
    </View>
  )
};


const ProductDetails = (props: IProps) => {
  const { product, sets, availableParams } = props;

  const selection = EuCutOutProductHelpers.deriveParameterSelection(product, sets, availableParams);

  return (
    <View style={styles.root}>
      <View style={styles.tableTitle}>
        <Text>Parameters:</Text>
      </View>

      <View style={styles.tableContainer}>
        <View style={[styles.row, styles.tableHead]}>
          <Text style={styles.shortname}>Parameter</Text>
          <Text style={styles.subset}>Subset name</Text>
          <Text style={styles.subsetType}>Subset type</Text>
        </View>
        {
          map(selection, item => <TableRow key={`${item.parameter.id}-${item.subset.id}`} item={item} />)
        }
      </View>

      <View style={styles.highFrequencyWrapper}>
        <Text style={styles.highFrequencyLabel}>High frequency products:</Text>
        <Text>{ product.data.high_frequency ? 'Yes' : 'No' }</Text>
      </View>
    </View>
  );
}

export default ProductDetails;
